<!-- 腾讯广告回传设置 -->
<template>
  <div>
    <!-- 标题 -->
    <div
      :style="{ width: table_scroll_width + 'px' }"
      style="position: relative"
    >
      <div
        :style="{ width: body_width + 'px' }"
        style="position: sticky; left: 30px; z-index: 5"
      >
        <!-- 标题 -->
        <div class="page-title">腾讯广告回传设置</div>

        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 12px 0 15px;
            position: sticky;
            left: 30px;
            z-index: 5;
          "
          :style="{ width: body_width + 'px' }"
        >
          <div class="screen-box" style="margin-bottom: 0">
            <div class="screen-label">公众号</div>

            <moreSelect
              ref="getGzhSelect"
              :placeholder="'请选择公众号'"
              :select_mode="''"
              @handleChangeSelect="handleChangeA"
            ></moreSelect>
          </div>

          <a-button
            @click="searchButton('button')"
            :loading="search_button_loading"
            type="primary"
            icon="search"
            style="margin-right: 20px"
            >搜索</a-button
          >
          <a-button
            @click="addButton"
            style="background-color: #67c23a; border-color: #67c23a"
            type="primary"
            >+ 新增</a-button
          >
        </div>
      </div>
    </div>

    <!-- 表头 -->
    <div
      class="table-th"
      ref="table_th"
      :style="{ width: table_scroll_width + 'px' }"
    >
      <div
        class="table-th-cell-sticky"
        style="display: flex; align-items: center"
      >
        <div
          class="table-th-cell"
          style="cursor: default"
          :style="{ width: rableTitle[0].width + 'px' }"
        >
          {{ rableTitle[0].title }}
        </div>
        <div
          class="table-th-cell"
          style="cursor: default"
          :style="{ width: rableTitle[1].width + 'px' }"
        >
          {{ rableTitle[1].title }}
        </div>
      </div>

      <div v-for="(item, index) in rableTitle" :key="index">
        <div
          v-if="index > 1"
          class="table-th-cell"
          :style="{
            width: item.width + 'px',
            cursor: item.sort_control ? 'pointer' : 'default',
            'justify-content': item.text_right ? 'flex-end' : '',
          }"
        >
          {{ item.title }}
          <div
            v-if="item.sort_control"
            style="
              display: flex;
              flex-direction: column;
              width: 12px;
              margin-left: 5px;
            "
          >
            <a-icon
              type="caret-up"
              :style="{ color: item.sort_status === 2 ? '#1890ff' : '#999' }"
              style="font-size: 12px; margin-bottom: -4px"
            />
            <a-icon
              type="caret-down"
              :style="{ color: item.sort_status === 1 ? '#1890ff' : '#999' }"
              style="font-size: 12px"
            />
          </div>
        </div>
      </div>
      <!-- 占位，隔出一个空白区域 -->
      <div id="" style="padding: 15px"></div>
    </div>

    <!-- 表格内容 -->
    <div
      v-for="(item, index) in tableShowData"
      :key="item.id"
      class="table-td"
      :style="{ width: table_scroll_width + 'px' }"
    >
      <div
        class="table-td-cell-sticky"
        style="display: flex; align-items: center"
      >
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[0].width + 'px' }"
        >
          {{ item.channel_name }}
        </div>
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[1].width + 'px' }"
        >
          {{ item.gzh_name }}
        </div>
      </div>
      <!-- 回传比例 -->
      <div
        @click="setPlanHcbl(item)"
        class="table-td-cell"
        :style="{ width: rableTitle[2].width + 'px' }"
        style="color: #62a8ea; cursor: pointer"
      >
        <div v-if="item.report_per" style="display: flex; align-items: center">
          <template v-if="item.report_per_type == 1">
            <div>
              固定序列<br />
              回传比例：{{ item.report_per }}
            </div>
          </template>
          <template v-else-if="item.report_per_type == 2">
            <div>自定义序列</div>
          </template>
        </div>
        <div v-else>未设置</div>
      </div>

      <!-- 回传参数 -->
      <div
        @click="setHcParams(item)"
        class="table-td-cell"
        :style="{ width: rableTitle[3].width + 'px' }"
        style="color: #62a8ea; cursor: pointer"
      >
        <div v-if="item.book_platform">
          <a-popover placement="top">
            <template slot="content">
              <div style="max-width: 500px">
                <div style="margin-bottom: 7px; word-break: break-all">
                  书城名称：{{ item.book_platform }}
                </div>
                <div style="margin-bottom: 7px; word-break: break-all">
                  回传作品名称：{{ item.book_name }}
                </div>
                <div style="word-break: break-all">
                  回传作品ID：{{ item.book_id }}
                </div>
              </div>
            </template>
            <div>已设置</div>
          </a-popover>
        </div>
        <div v-else>未设置</div>
      </div>
      <!-- MP上报方式 -->
      <div
        @click="editTable(item, 1)"
        class="table-td-cell"
        :style="{ width: rableTitle[4].width + 'px' }"
        style="color: #62a8ea; cursor: pointer"
      >
        <span v-if="item.is_open_qywx == 1">添加企微</span>
        <span v-else-if="item.is_open_qywx == 0">公众号关注</span>
        <br />
        <template v-if="item.is_open_qywx == 1">
          {{ item.mp_check_type | qwCheckType }}
        </template>
        <template v-else-if="item.is_open_qywx == 0">
          {{ item.mp_check_type | gzhCheckType }}
        </template>
      </div>
      <!-- 是否开启MP上报 -->
      <!-- <div class="table-td-cell" :style="{ width: rableTitle[5].width + 'px' }">
        <a-switch
          @change="openMp($event, index)"
          :loading="item.open_mp_loading"
          :checked="!!item.is_open_mp"
          checked-children="开启"
          un-checked-children="关闭"
        />
      </div> -->
      <div class="table-td-cell" :style="{ width: rableTitle[5].width + 'px' }">
        <div class="auth_top">
          <a-tooltip>
            <template #title>
              <span>点击前往授权</span>
            </template>
            <div
              :class="[
                'auth_btn',
                item.auth_adq_time > 0 ? 'active' : 'unactive',
              ]"
              @click="authClick(item.adq_auth_url)"
            >
              {{ item.auth_adq_time > 0 ? "已授权" : "未授权" }}
            </div>
          </a-tooltip>
        </div>
        <div>{{ item.auth_adq_time | formatTime }}</div>
      </div>

      <!-- 接口版本  1=老接口，2=新接口-->
      <div class="table-td-cell" :style="{ width: rableTitle[6].width + 'px' }">
        <div class="auth_top">
          <div
            :class="[
              'auth_btn',
              item.adq_api_version === 2 ? 'active' : 'unactive',
            ]"
            @click="openReplaceModal(item.id, item.adq_api_version)"
          >
            {{ item.adq_api_version === 2 ? "新版接口" : "老版接口" }}
          </div>
          <!-- <div class="auth_text" @click="authClick(item.adq_auth_url)">
            授权公众号
          </div> -->
        </div>
      </div>

      <!-- MP数据源ID(Wechat类型) -->
      <!-- <div class="table-td-cell" :style="{ width: rableTitle[6].width + 'px' }">
        {{ item.user_action_set_id }}
      </div> -->

      <!-- 是否开启ADQ上报 -->
      <div class="table-td-cell" :style="{ width: rableTitle[7].width + 'px' }">
        <a-switch
          @change="openAdq($event, index)"
          :loading="item.open_adq_loading"
          :checked="!!item.is_open_adq"
          checked-children="开启"
          un-checked-children="关闭"
        />
      </div>
      <!-- ADQ数据源ID(Web类型) -->
      <div class="table-td-cell" :style="{ width: rableTitle[8].width + 'px' }">
        {{ item.adq_user_action_set_id }}
      </div>

      <!-- 引导方式 -->
      <!-- <div class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}"> -->
      <!-- <div @click="editTable(item,2)" style="color: #62a8ea;cursor: pointer;">
        {{item.is_open_qywx == 1?'添加企微':'公众号关注'}}
        </div> -->
      <!-- </div> -->
      <!-- MP Feedback URL -->
      <div
        class="table-td-cell"
        :style="{ width: rableTitle[9].width + 'px' }"
        style="cursor: pointer"
      >
        <a-tooltip placement="top">
          <template slot="title">
            <div>{{ item.mp_feedback_url }}</div>
          </template>
          <a-button type="link" class="copy-text" @click="mkUrlCopy(item)"
            >复制旧版URL
            <a-icon type="copy" style="font-size: 13px; margin-left: 2px"
          /></a-button>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <div>{{ item.new_mp_feedback_url }}</div>
          </template>
          <a-button type="link" class="copy-text" @click="newUrlCopy(item)"
            >复制新版URL
            <a-icon type="copy" style="font-size: 13px; margin-left: 2px"
          /></a-button>
        </a-tooltip>

        <!-- <a-icon type="copy" style="font-size: 13px;"/> -->
      </div>

      <!-- 点击监测链接 -->
      <div
        class="table-td-cell"
        :style="{ width: rableTitle[10].width + 'px' }"
        style="cursor: pointer"
      >
        <!-- <div v-if="item.tencent_click_url" @click="txUrlCopy(item)">
          {{item.tencent_click_url}}
          <a-icon type="copy" style="font-size: 13px;"/>
        </div> -->

        <a-tooltip placement="top">
          <template slot="title">
            <div>{{ item.tencent_click_url }}</div>
          </template>
          <a-button type="link" class="copy-text" @click="txUrlCopy(item)"
            >复制旧版URL
            <a-icon type="copy" style="font-size: 13px; margin-left: 2px"
          /></a-button>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <div>{{ item.new_tencent_click_url }}</div>
          </template>
          <a-button type="link" class="copy-text" @click="newTenUrlCopy(item)"
            >复制新版URL
            <a-icon type="copy" style="font-size: 13px; margin-left: 2px"
          /></a-button>
        </a-tooltip>
      </div>

      <!-- 操作 -->
      <div
        class="table-td-cell"
        :style="{ width: rableTitle[11].width + 'px' }"
        style="display: flex; flex-wrap: wrap"
      >
        <!-- <div @click="setPlanHcbl(item)" class="td-cz" style="color: #62a8ea;">编辑</div> -->
        <div @click="delTd(item)" class="td-cz" style="color: red">删除</div>
      </div>
    </div>

    <div
      v-show="tableShowData.length === 0"
      style="text-align: center; margin: 80px 0 50px"
      :style="{ width: table_null_width + 'px' }"
    >
      <a-icon style="font-size: 70px; color: #999" type="file-search" />

      <div style="color: #999; font-size: 16px; margin-top: 20px">内容为空</div>
    </div>

    <div
      style="
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 6;
        background-color: #fff;
        height: calc(100vh - 65px);
        width: 30px;
      "
    ></div>
    <div
      style="
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 6;
        background-color: #fff;
        height: calc(100vh - 65px);
        width: 30px;
      "
    ></div>

    <!-- 分页 -->
    <pagingCompont
      :table_scroll_width="table_scroll_width"
      :table_null_width="table_null_width"
      :r_page="r_page"
      :r_limit="r_limit"
      :table_total="table_total"
      @pagination-Change="paginationChange"
      @change-size-limit="changeSizeLimit"
    ></pagingCompont>

    <!-- 编辑单项的弹窗 -->
    <a-modal
      :title="`编辑${edit_modal_title}`"
      :visible="edit_visible"
      :confirm-loading="confirmLoading"
      cancelText="取消"
      okText="确认"
      width="650px"
      @ok="editModalOk"
      @cancel="editModalCancel"
    >
      <div class="screen-box" style="margin-bottom: 20px">
        <div class="screen-label" style="width: 90px">引导方式</div>
        <a-select
          style="width: 400px"
          placeholder="请选择"
          @change="handleChangeY"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="e_qywx"
        >
          <a-select-option :value="0"> 公众号关注 </a-select-option>
          <a-select-option :value="1"> 添加企微 </a-select-option>
        </a-select>
      </div>

      <div class="screen-box">
        <div class="screen-label" style="width: 90px">上报方式</div>
        <a-select
          style="width: 400px"
          placeholder="请选择"
          @change="handleChangeG"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="e_mp_check_type"
        >
          <a-select-option value="2">不核对广告计划</a-select-option>
          <template v-if="e_qywx == 0">
            <a-select-option value="1"
              >核对广告计划(公众号关注feedback)</a-select-option
            >
          </template>
          <template v-else-if="e_qywx == 1">
            <a-select-option value="1"
              >核对广告计划(添加企微feedback)</a-select-option
            >
            <a-select-option value="3"
              >核对广告计划(腾讯点击监测)</a-select-option
            >
          </template>
        </a-select>
      </div>
    </a-modal>

    <!-- 回传比例相关侧边栏 -->
    <a-drawer
      :title="`${hc_drawer_title}回传设置`"
      width="750px"
      placement="right"
      :closable="false"
      :visible="hc_visible"
      @close="hcCloseDrawer"
    >
      <div v-if="hc_drawer_title == '新增'" class="form-cell-box">
        <div class="class-title">公众号</div>

        <!-- <a-select
          show-search
            style="min-width: 260px"
            placeholder="请选择公众号"
            @change="handleChangeB"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="h_gzh_id"
          >
            <a-select-option v-for="(item,index) in filterList.gzh_id.list" :key="item.key" :value="item.key">
              {{item.value}}
            </a-select-option>
        </a-select> -->
        <moreSelect
          ref="getGzhSelectDrawer"
          :placeholder="'请选择公众号'"
          :select_mode="''"
          @handleChangeSelect="handleChangeB"
        ></moreSelect>
      </div>

      <div v-if="hc_drawer_title == '编辑'" class="form-cell-box">
        <div class="class-title">公众号</div>

        <div>{{ h_gzh_name }}</div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">回传最低金额(元)</div>

        <a-input-number
          @change="hcNumber($event, 1)"
          :min="0"
          :max="100000"
          :value="h_report_money_limit"
          style="width: 130px"
        />
      </div>

      <div class="form-cell-box">
        <div class="class-title">注册时间</div>

        <div>
          <a-radio-group
            @change="hcRadioA"
            name="radioGroup"
            :value="h_user_reg_time_condition"
          >
            <a-radio :value="1"> 只传注册当天用户 </a-radio>
            <a-radio :value="0"> 注册时间不限 </a-radio>
          </a-radio-group>
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">充值时间</div>

        <div>
          <a-radio-group
            @change="hcRadioB"
            name="radioGroup"
            :value="h_order_time_condition_type"
            style="width: 100%"
          >
            <a-radio :value="1"> 注册日期当天首次充值 </a-radio>
            <a-radio :value="0" style="width: 260px">
              <div style="display: inline-block; align-items: center">
                注册后
                <a-input-number
                  @change="hcNumber($event, 2)"
                  :min="0"
                  :max="100000"
                  :value="h_order_time_condition_n"
                  style="width: 80px; margin: 0 5px"
                />
                小时内首次充值
              </div>
            </a-radio>
          </a-radio-group>
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">回传比例</div>

        <a-input-number
          @change="hcNumber($event, 3)"
          :min="0"
          :max="100000"
          :value="h_report_per"
          style="width: 130px"
        />
      </div>

      <div class="form-cell-box" style="margin-bottom: 20px; margin-top: 20px">
        <div class="class-title">事件类型</div>
        <div>
          <a-radio-group
            @change="hcRadioS"
            name="radioGroup"
            :value="h_report_type"
          >
            <a-radio :value="1"> 下单事件 </a-radio>
            <a-radio :value="2"> 付费事件 </a-radio>
          </a-radio-group>
        </div>
      </div>
      <div v-if="h_report_type == 2" class="form-cell-box">
        <div class="class-title">是否全量回传</div>
        <div>
          <a-radio-group
            @change="hcRadioF"
            name="radioGroup"
            :value="h_report_all"
          >
            <a-radio :value="1"> 全量 </a-radio>
            <a-radio :value="0"> 不全量 </a-radio>
          </a-radio-group>
          <span style="margin-left: 15px; color: #8d8b8b"
            >说明：用于回传腾讯时，告知腾讯是否为全量回传。</span
          >
        </div>
      </div>

      <div class="form-cell-box" style="margin-bottom: 20px; margin-top: 20px">
        <div class="class-title">补充事件类型</div>
        <div>
          <a-checkbox-group
            v-model="h_report_other_type"
            :options="['关键页面访问', '在线咨询', '关键行为']"
            @change="hcChangeA"
          />
        </div>
      </div>

      <!-- <div class="form-cell-box">
        <div class="class-title">是否启用</div> 
          
        <a-switch @change="hcDrawerSwitch" :checked="h_status" checked-children="启用" un-checked-children="暂停" />
      </div> -->

      <div
        style="
          color: red;
          height: 23px;
          margin-top: 25px;
          margin-bottom: -10px;
          margin-left: 40px;
        "
      >
        {{ hc_form_hint }}
      </div>

      <div class="form-cell-box" style="margin-top: 30px; padding-left: 41px">
        <a-button
          @click="hcRequest"
          :loading="hc_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="hcCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 设置回传参数侧边栏 -->
    <a-drawer
      :title="`设置回传参数`"
      width="650px"
      placement="right"
      :closable="false"
      :visible="params_visible"
      @close="paramsCloseDrawer"
    >
      <div class="form-cell-box">
        <span style="padding-left: 40px; color: red"
          >请保证准确填写，否则影响投放效果</span
        >
      </div>
      <div class="form-cell-box">
        <div class="class-title">书城<span class="required-hint">*</span></div>
        <a-input
          v-model="p_book_platform"
          placeholder="请输入书城名称"
          style="width: 390px"
        />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          回传作品名称<span class="required-hint">*</span>
        </div>
        <a-input
          v-model="p_book_name"
          placeholder="请输入回传作品名称"
          style="width: 390px"
        />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          回传作品ID<span class="required-hint">*</span>
        </div>
        <a-input
          v-model="p_book_id"
          placeholder="请输入回传作品ID"
          style="width: 390px"
        />
      </div>

      <div
        style="
          color: red;
          height: 23px;
          margin-top: 25px;
          margin-bottom: -10px;
          margin-left: 40px;
        "
      >
        {{ params_form_hint }}
      </div>

      <div class="form-cell-box" style="margin-top: 30px; padding-left: 41px">
        <a-button
          @click="paramsRequest"
          :loading="params_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="paramsCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 回传比例侧边栏 -->
    <txHcDrawer
      ref="txHcRef"
      page_type="TxAdvHc"
      @hc-request="hcRequestD"
      @select-gzh="handleChangeB"
    ></txHcDrawer>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
    <a-modal
      :visible="replaceVisible"
      title="提示"
      @ok="changeApiVersion"
      @cancel="handleCancel"
      :confirm-loading="replaceLoading"
    >
      <p>是否切换到{{ replaceType === 1 ? "新版接口" : "老版接口" }}</p>
    </a-modal>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {
  TxMpAdqHcList,
  TxMpAdqAddReport,
  TxMpAdqCheckType,
  putDataMenu,
  TxMpAdqChangeOpen,
  TxMpAdqEditReport,
  TxMpAdqDelReport,
  TxMpAdqEditBook,
  TxMpAdqChangeQywx,
  replaceApiVersion,
  successCodeArr,
} from "@/request/api";
import moreSelect from "@/components/selectCompont/moreSelect.vue";
import txHcDrawer from "@/views/Market/components/txHcDrawer.vue";
export default {
  name: "TxAdvHc_",
  components: {
    moreSelect,
    txHcDrawer,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      moment,

      r_limit: 50,
      r_page: 1,
      r_sort_field: "", // 要排序的字段
      r_sort_type: "", // 排序方式

      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        // {title:"渠道",width:100, sort_status:0, type:"channel_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        // {title:"公众号",width:100, sort_status:0, type:"gzh_name",},

        // {title:"回传比例",width:150, sort_status:0, type:"report_per", },

        // {title:"回传参数",width:100, sort_status:0, type:"", },
        // {title:"推广链路",width:240, sort_status:0, type:"mp_check_type",},

        // {title:"开启MP上报",width:130, sort_status:0, type:"is_open_mp",},
        // {title:"MP数据源ID（WeChat类型）",width:200, sort_status:0, type:"user_action_set_id",},
        // {title:"开启ADQ上报",width:130, sort_status:0, type:"is_open_adq",},
        // {title:"ADQ数据源ID（Web类型）",width:200, sort_status:0, type:"adq_user_action_set_id",},

        // // {title:"引导方式",width:130, sort_status:0, type:"",},

        // {title:"Feedback URL(所有流量通用)",width:200, sort_status:0, type:"mp_feedback_url",},
        // {title:"点击监测链接",width:200, sort_status:0, type:"tencent_click_url",},
        // {title:"操作",width:100, sort_status:0, type:"cz",},

        { title: "渠道", width: 100, sort_status: 0, type: "channel_name" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "公众号", width: 100, sort_status: 0, type: "gzh_name" },

        { title: "回传比例", width: 150, sort_status: 0, type: "report_per" },

        { title: "回传参数", width: 100, sort_status: 0, type: "" },
        {
          title: "推广链路",
          width: 240,
          sort_status: 0,
          type: "mp_check_type",
        },

        // {title:"开启MP上报",width:130, sort_status:0, type:"is_open_mp",},
        {
          title: "授权腾讯ADQ平台",
          width: 200,
          sort_status: 0,
          type: "user_action_set_id",
        },
        {
          title: "接口版本",
          width: 120,
          sort_status: 0,
          type: "adq_api_version",
        },
        {
          title: "开启ADQ上报",
          width: 130,
          sort_status: 0,
          type: "is_open_adq",
        },
        {
          title: "数据源ID",
          width: 200,
          sort_status: 0,
          type: "adq_user_action_set_id",
        },

        // {title:"引导方式",width:130, sort_status:0, type:"",},

        {
          title: "Feedback URL(所有流量通用)",
          width: 200,
          sort_status: 0,
          type: "mp_feedback_url",
        },
        {
          title: "点击监测链接",
          width: 200,
          sort_status: 0,
          type: "tencent_click_url",
        },
        { title: "操作", width: 100, sort_status: 0, type: "cz" },
      ],
      tableShowData: [],
      table_total: 0, // 表格内容总数
      table_scroll_width: 1600,
      body_width: 1600, // body的宽度
      table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
      search_button_loading: false, // 搜索按钮的加载状态

      visible: false,

      r_channel_id: "", // 渠道
      r_gzh_id: undefined, // 公众号

      visible: false,
      add_button_loading: false, // 新增侧边栏的确认按钮加载状态
      add_form_hint: "", // 侧边栏新增表单的验证提示

      // 单个编辑弹窗
      edit_visible: false, // 编辑弹窗的显示
      edit_modal_title: "", // 编辑弹窗的标题
      confirmLoading: false,
      e_id: "", // 编辑请求用的id
      e_mp_check_type: undefined, // MP上报方式
      e_qywx: undefined, // ADQ企业微信方式切换
      e_qywx_save: undefined, // ADQ企业微信方式切换-保存

      // 回传比例侧边栏
      hc_plan_id: "", // 回传id
      hc_drawer_title: "", // 标题
      hc_visible: false, // 侧边栏是否显示
      hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
      hc_form_hint: "",

      h_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
      h_user_reg_time_condition: 1, // 注册时间
      h_order_time_condition_type: 1, // 充值时间
      h_order_time_condition_n: 24, // 注册后几小时内首次充值
      h_report_per: 100, // 回传比例
      h_status: true, // 是否启用-回传侧边栏
      h_gzh_id: undefined, // 回传侧边栏-投放公众号
      h_gzh_name: "", // 回传公众号名字
      h_edit_id: "", // 回传编辑用的id
      h_report_all: 1, // 是否全量回传 0=否，1=是
      h_report_type: 1, // 事件类型 1下单时间，2付费事件
      h_report_other_type: [], // 1=关键页面访问，2=在线咨询，3=关键行为

      // 筛选条件部分
      filterList: {
        op_id: {
          list: [{}],
        },
        media_id: {
          list: [{}],
        },
        channel_id: {
          list: [{}],
        },
        gzh_id: {
          list: [{}],
        },
      }, // 筛选条件数组

      // 回传参数设置
      params_visible: false, // 侧边栏控制
      p_id: null,
      p_book_name: null, // 书籍名称
      p_book_platform: null, // 书城名称
      p_book_id: null,
      p_book_url: null,
      params_form_hint: "", // 校验提示
      params_button_loading: false,

      // 公众号下拉框-带下滑加载-带搜索
      gzhfilterList: [], // 公众号下拉选择框的数据
      gzhFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
      gzhFilterSearch: [], // 下拉框搜索后的存放数据
      gzh_page: 0,
      gzh_limit: 50,
      // 公众号下拉框-结束

      // 切换版本
      replaceId: null,
      replaceVisible: false,
      replaceLoading: false,
      replaceType: 1,
    };
  },
  mounted() {
    let that = this;

    // 获取表格信息
    let table_info = this.$getTableInfo(that.rableTitle);
    console.log("table_info", table_info);
    that.body_width = table_info.body_width;
    that.table_scroll_width = table_info.table_width;
    that.table_null_width = table_info.null_width;

    setTimeout(() => {
      // 给母页面的tab传递粘性定位用的参数
      that.$bus.$emit("stickyData", that.table_scroll_width);
    }, 300);

    putDataMenu().then((res) => {
      console.log("获取搜索条件", res);
      that.filterList = res.data.data.filter;

      that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || []);
    });

    that.searchButton();
  },
  methods: {
    handleCancel() {
      this.replaceVisible = false;
      this.replaceLoading = false;
      this.replaceType = 1;
      this.replaceId = null;
    },
    openReplaceModal(id, type) {
      this.replaceId = id;
      this.replaceType = type;
      this.replaceVisible = true;
    },
    async changeApiVersion() {
      try {
        this.replaceLoading = true;
        const result = await replaceApiVersion({ id: this.replaceId });
        if (result.data.code === -1 && result.data.msg) {
          this.$message.error(result.data.msg);
        } else if (successCodeArr.includes(result.data.code)) {
          this.$message.success(
            `切换到${this.replaceType === 1 ? "新版接口" : "老版接口"}成功`
          );
          this.handleCancel();
          this.searchButton();
        }
      } catch (error) {
      } finally {
        this.replaceLoading = false;
      }
    },
    authClick(url) {
      window.open(url);
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeA(e) {
      console.log(e);
      this.r_gzh_id = e;
    },
    handleChangeB(e) {
      this.h_gzh_id = e;
    },
    // MP上报方式
    handleChangeG(e) {
      this.e_mp_check_type = e;
    },
    handleChangeY(e) {
      this.e_qywx = e;
      this.e_mp_check_type = undefined;
    },
    // 搜索
    searchButton(type) {
      let that = this;

      if (type == "button") {
        that.r_page = 1;
      }

      that.search_button_loading = true;
      let r_data = {
        limit: that.r_limit,
        page: that.r_page,
      };
      if (that.r_gzh_id) {
        // 公众号
        r_data.gzh_id = that.r_gzh_id;
      }

      TxMpAdqHcList(r_data)
        .then((res) => {
          console.log("搜索结果", res);
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            if (type) {
              that.$message.success("搜索成功");
            }
            that.search_button_loading = false;
            that.table_total = res.data.data.total;
            let data = res.data.data.data;
            data.forEach((res) => {
              res.open_mp_loading = false;
              res.open_adq_loading = false;
            });
            that.tableShowData = data;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }

          // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
          setTimeout(() => {
            document
              .querySelector("body")
              .setAttribute("style", "overflow-x: visible;");
          }, 100);
        })
        .catch((err) => {
          console.log(err);
          that.$message.error("搜索失败，可能是网络出现问题");
        });
    },

    // 分页的页数变化
    paginationChange(e) {
      console.log(e);
      this.r_page = e;
      this.searchButton();
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },

    // 编辑弹窗取消
    editModalCancel() {
      this.edit_visible = false;
      this.confirmLoading = false;
    },

    // 巨量链接复制
    mkUrlCopy(e) {
      console.log(e);
      let that = this;
      this.$copyText(e.mp_feedback_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },
    //新版url复制
    newUrlCopy(e) {
      console.log(e);
      let that = this;
      this.$copyText(e.new_mp_feedback_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },
    // 点击检测链接
    txUrlCopy(e) {
      let that = this;
      this.$copyText(e.tencent_click_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },

    // 点击新检测链接
    newTenUrlCopy(e) {
      let that = this;
      this.$copyText(e.new_tencent_click_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },

    // 编辑弹窗确认按钮
    editModalOk() {
      let that = this;

      if (!this.e_qywx && this.e_qywx != 0) {
        that.$message.warning(`请选择引导方式`);
        return;
      } else if (!this.e_mp_check_type) {
        that.$message.warning(`请选择上报方式`);
        return;
      }

      let r_data = {
        id: that.e_id, // 推广链接id
        is_open_qywx: that.e_qywx, // 引导方式
      };
      // if(that.edit_modal_title == "MP上报方式"){
      r_data.mp_check_type = that.e_mp_check_type; // MP上报方式
      // }

      that.confirmLoading = true;

      // if(that.edit_modal_title == "MP上报方式"){
      TxMpAdqCheckType(r_data).then((res) => {
        console.log("编辑弹窗确认按钮", res);
        that.confirmLoading = false;
        if (res.data.code == 0) {
          that.editModalCancel();
          that.$message.success("编辑成功");
          that.searchButton();
        } else {
          that.$message.error(res.data.msg);
        }
      });
      // }
      // else if(that.edit_modal_title == "引导方式"){
      // 	if(that.e_qywx != that.e_qywx_save){
      // 		TxMpAdqChangeQywx(r_data).then(res=>{
      // 			console.log("引导方式",res);
      // 			that.editModalCancel()
      // 			that.$message.success('编辑成功');
      // 			that.searchButton()
      // 		})
      // 	}
      // 	else {
      // 		that.editModalCancel()
      // 	}
      // }
    },
    // 编辑弹窗取消
    editModalCancel() {
      // if(this.confirmLoading){
      // 	return
      // }
      this.confirmLoading = false;
      this.edit_visible = false;
    },
    editTable(e, type) {
      console.log(e, type);
      // if(type == 1){ // MP上报方式
      this.edit_modal_title = "推广链路";
      // this.edit_modal_title = 'MP上报方式'
      this.e_id = e.id;

      this.e_mp_check_type = e.mp_check_type.toString();

      // this.edit_visible = true
      // }
      // else if(type == 2){ // 引导方式

      // this.edit_modal_title = '引导方式'
      // this.e_id = e.id

      this.e_qywx = e.is_open_qywx;
      this.e_qywx_save = e.is_open_qywx;

      this.edit_visible = true;
      // }
    },

    hcRequestD(r_data) {
      let that = this;
      if (that.hc_drawer_title == "新增") {
        r_data.gzh_id = that.h_gzh_id;
        TxMpAdqAddReport(r_data)
          .then((res) => {
            // that.hc_button_loading = false
            console.log("确认设置回传", res);
            if (res.data.code == 0) {
              that.$refs.txHcRef.hcCloseDrawer();

              that.$message.success("设置成功");
              that.searchButton();
            } else {
              that.$refs.txHcRef.closeLoading();
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          })
          .catch((err) => {
            that.$refs.txHcRef.closeLoading();
            // that.hc_button_loading = false
            // that.hcCloseDrawer()
            that.$message.error(`错误${err}`);
          });
      } else if (that.hc_drawer_title == "编辑") {
        r_data.id = that.h_edit_id;
        TxMpAdqEditReport(r_data)
          .then((res) => {
            // that.hc_button_loading = false
            console.log("确认设置回传", res);
            if (res.data.code == 0) {
              that.$refs.txHcRef.hcCloseDrawer();

              that.$message.success("设置成功");
              that.searchButton();
            } else {
              that.$refs.txHcRef.closeLoading();
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          })
          .catch((err) => {
            that.$refs.txHcRef.closeLoading();
            // that.hc_button_loading = false
            // that.hcCloseDrawer()
            that.$message.error(`错误${err}`);
          });
      }
    },
    // 计划回传比例侧边栏开始
    setPlanHcbl(e) {
      console.log("jh", e);
      this.$refs.txHcRef.setPlanHcbl(e, "gzh", e.gzh_name);
      this.hc_drawer_title = "编辑";
      this.h_gzh_name = e.gzh_name;
      this.h_edit_id = e.id;
      return;

      let that = this;

      // this.h_gzh_id = e.gzh_id
      this.h_gzh_name = e.gzh_name;
      this.h_edit_id = e.id;

      (this.h_report_money_limit = e.report_money_limit), // 回传最低金额
        (this.h_user_reg_time_condition = e.user_reg_time_condition), // 注册时间
        (this.h_order_time_condition_type = e.order_time_condition_type), // 充值时间
        (this.h_order_time_condition_n = e.order_time_condition_n), // 注册后几小时内首次充值
        (this.h_report_per = e.report_per); // 回传比例
      this.h_report_type = e.report_type || 1; // 默认值为1表示下单事件
      if (e.report_type == 2) {
        this.h_report_all = e.report_all == 0 ? 0 : 1;
      }

      // 补充事件类型
      if (e.report_other_type) {
        let o_arr = [];
        e.report_other_type.forEach((res) => {
          if (res == 1) {
            o_arr.push("关键页面访问");
          } else if (res == 2) {
            o_arr.push("在线咨询");
          } else if (res == 3) {
            o_arr.push("关键行为");
          }
        });
        this.h_report_other_type = o_arr;
      } else {
        this.h_report_other_type = [];
      }

      // if(ee.status == 1){ // 启用
      // 	this.h_status = true // 是否启用-回传侧边栏
      // }
      // else {
      // 	this.h_status = false
      // }

      this.hc_visible = true;
    },
    // 回传比例确认按钮
    hcRequest() {
      let that = this;

      if (!that.h_gzh_id && that.hc_drawer_title == "新增") {
        that.$message.warning("请选择公众号");
        return;
      }

      that.hc_button_loading = true;

      let r_data = {
        report_money_limit: that.h_report_money_limit.toString(), // 回传最低金额
        user_reg_time_condition: that.h_user_reg_time_condition.toString(), // 注册时间
        order_time_condition_type: that.h_order_time_condition_type.toString(), // 充值时间
        report_per: that.h_report_per.toString(), // 回传比例

        report_type: that.h_report_type, // 事件类型
      };
      if (that.h_report_type == 2) {
        // 是否全量回传
        r_data.report_all = that.h_report_all;
      }
      // if(that.h_status){// 是否启用
      // 	r_data.status = 1 // 启用
      // }
      // else {
      // 	r_data.status = 0
      // }
      // 选了注册后充值
      if (that.h_order_time_condition_type == 0) {
        r_data.order_time_condition_n = that.h_order_time_condition_n; // 注册后几小时内首次充值
      }

      // 补充事件类型
      if (that.h_report_other_type.length > 0) {
        let sj_arr = [];
        that.h_report_other_type.forEach((res) => {
          if (res == "关键页面访问") {
            sj_arr.push(1);
          } else if (res == "在线咨询") {
            sj_arr.push(2);
          } else if (res == "关键行为") {
            sj_arr.push(3);
          }
        });

        r_data.report_other_type = sj_arr;
      }

      if (that.hc_drawer_title == "新增") {
        r_data.gzh_id = that.h_gzh_id;
        TxMpAdqAddReport(r_data)
          .then((res) => {
            that.hc_button_loading = false;
            console.log("确认设置回传", res);
            if (res.data.code == 0) {
              that.$refs.txHcRef.hcCloseDrawer();

              that.$message.success("设置成功");
              that.searchButton();
            } else {
              that.$refs.txHcRef.closeLoading();
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          })
          .catch((err) => {
            that.$refs.txHcRef.closeLoading();
            // that.hc_button_loading = false
            // that.hcCloseDrawer()
            that.$message.error(`错误${err}`);
          });
      } else if (that.hc_drawer_title == "编辑") {
        r_data.id = that.h_edit_id;
        TxMpAdqEditReport(r_data)
          .then((res) => {
            that.hc_button_loading = false;
            console.log("确认设置回传", res);
            if (res.data.code == 0) {
              that.$refs.txHcRef.hcCloseDrawer();

              that.$message.success("设置成功");
              that.searchButton();
            } else {
              that.$refs.txHcRef.closeLoading();
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          })
          .catch((err) => {
            that.$refs.txHcRef.closeLoading();
            // that.hc_button_loading = false
            // that.hcCloseDrawer()
            that.$message.error(`错误${err}`);
          });
      }
    },
    // 回传比例侧边栏关闭
    hcCloseDrawer() {
      if (this.hc_button_loading) {
        return;
      }
      // console.log('111111');
      this.hc_visible = false;
      this.hc_form_hint = "";
      // 充值状态
      (this.h_report_money_limit = window.$InitialValues.report_money_limit), // 回传最低金额
        (this.h_user_reg_time_condition = 1), // 注册时间
        (this.h_order_time_condition_type = 1), // 充值时间
        (this.h_order_time_condition_n = 24), // 注册后几小时内首次充值
        (this.h_report_per = 100); // 回传比例
      this.h_status = true;
      this.h_plan_id = "";
      this.h_gzh_id = undefined; // 回传侧边栏-投放公众号
      this.h_gzh_name = ""; // 回传公众号名字
      this.h_edit_id = ""; // 回传编辑用的id

      this.h_report_type = 1;
      this.h_report_all = 1;

      this.h_report_other_type = [];

      document
        .querySelector("body")
        .setAttribute("style", "overflow-x: visible;");
      setTimeout(() => {
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
      }, 300);
    },
    // 回传比例侧边栏的是否启用按钮
    hcDrawerSwitch(e) {
      console.log(e);
      this.h_status = e;
    },
    hcRadioA(e) {
      // 注册时间
      console.log(e.target.value);
      this.h_user_reg_time_condition = e.target.value;
    },
    hcRadioB(e) {
      // 充值时间
      console.log(e.target.value);
      this.h_order_time_condition_type = e.target.value;
    },
    // 回传比例的数字输入框
    hcNumber(e, type) {
      console.log(e, type);
      if (type == 1) {
        // 回传最低金额(元)
        this.h_report_money_limit = e;
      } else if (type == 2) {
        // 注册后几小时内首次充值
        this.h_order_time_condition_n = e;
      } else if (type == 3) {
        // 回传比例
        this.h_report_per = e;
      }
    },
    hcRadioS(e) {
      // 事件类型
      this.h_report_type = e.target.value;
    },
    hcRadioF(e) {
      // 是否全量回传 0=否，1=是，自定义回传比率才有
      this.h_report_all = e.target.value;
    },
    hcChangeA(e) {
      // 补充事件类型
      // console.log(e);
      this.h_report_other_type = e;
    },

    // 删除
    delTd(e) {
      let that = this;
      this.$confirm({
        title: "确定要删除吗?",
        content: `选中的选项：${e.channel_name}-${e.gzh_name}`,
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          TxMpAdqDelReport({
            id: e.id,
          }).then((res) => {
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("删除成功");
              that.searchButton();
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },

    // 新增按钮
    addButton() {
      let that = this;
      this.hc_drawer_title = "新增";
      // this.hc_visible = true

      this.$refs.txHcRef.gzhAddShow();

      // that.$nextTick(()=>{
      // 	that.$refs.getGzhSelectDrawer.getSelectData(that.filterList.gzh_id.list || [])
      // })
    },
    // 是否开启MP上报
    openMp(e, index) {
      let that = this;
      if (that.tableShowData[index].is_open_adq == 1) {
        that.$message.warning("MP上报、ADQ上报，只能同时开启一个");
        return;
      }
      console.log(e, index);
      this.tableShowData[index].open_mp_loading = true;
      let o_p;
      if (e) {
        o_p = 1; // 打开
      } else {
        o_p = 0; // 关闭
      }
      TxMpAdqChangeOpen({
        id: that.tableShowData[index].id,
        is_open: o_p,
        source_type: "WECHAT",
      }).then((res) => {
        console.log("是否打开投放", res);
        that.tableShowData[index].open_mp_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          that.tableShowData[index].is_open_mp = e;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },
    // 是否开启ADQ上报
    openAdq(e, index) {
      let that = this;
      // if (that.tableShowData[index].is_open_mp == 1) {
      //   that.$message.warning("MP上报、ADQ上报，只能同时开启一个");
      //   return;
      // }
      this.tableShowData[index].open_adq_loading = true;
      let o_p;
      if (e) {
        o_p = 1; // 打开
      } else {
        o_p = 0; // 关闭
      }
      TxMpAdqChangeOpen({
        id: that.tableShowData[index].id,
        is_open: o_p,
        source_type: "WEB",
      }).then((res) => {
        that.tableShowData[index].open_adq_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          that.tableShowData[index].is_open_adq = e;
          that.searchButton();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },

    // 回传参数设置
    setHcParams(e) {
      this.p_id = e.id;
      this.p_book_platform = e.book_platform;
      this.p_book_name = e.book_name;
      this.p_book_id = e.book_id;
      this.p_book_url = e.book_url;

      this.params_visible = true;
    },
    paramsRequest() {
      // 确认按钮
      let that = this;
      if (!that.p_book_platform) {
        that.params_form_hint = "书城名称不能为空";
      } else if (!that.p_book_name) {
        that.params_form_hint = "回传作品名称不能为空";
      } else if (!that.p_book_id) {
        that.params_form_hint = "回传作品ID不能为空";
      } else {
        that.params_form_hint = "";
        that.params_button_loading = true;
        TxMpAdqEditBook({
          id: that.p_id,
          book_name: that.p_book_name,
          book_platform: that.p_book_platform,
          book_id: that.p_book_id,
          book_url: that.p_book_url,
        }).then((res) => {
          that.params_button_loading = false;
          console.log("回传参数确认", res);
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success("操作成功");
            that.paramsCloseDrawer();
            that.searchButton();
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      }
    },
    paramsCloseDrawer() {
      // 关闭
      this.p_id = null;
      this.p_book_name = null;
      this.p_book_platform = null;
      this.p_book_id = null;
      this.p_book_url = null;
      this.params_visible = false;
    },
  },
  filters: {
    gzhCheckType(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "核对广告计划(公众号关注feedback)";
      } else if (value == 2) {
        vvv = "不核对广告计划";
      }
      // else if(value == 3){
      // 	vvv = "核对点击日志"
      // }
      return vvv;
    },
    qwCheckType(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "核对广告计划(添加企微feedback)";
      } else if (value == 2) {
        vvv = "不核对广告计划";
      } else if (value == 3) {
        vvv = "核对广告计划(腾讯点击监测)";
      }
      return vvv;
    },
    formatTime(val) {
      if (val > 0) {
        const date = new Date(val * 1000); // 参数需要毫秒数，所以这里将秒数乘于 1000
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D = date.getDate() + " ";
        const h = date.getHours() + ":";
        const m = date.getMinutes() + ":";
        const s = date.getSeconds();
        return `${Y}${M}${D}${h}${m}${s}`;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.auth_top {
  display: flex;
  margin-bottom: 6px;
}
.auth_btn {
  padding: 2px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.auth_btn.active {
  background-color: #e0eecc;
  color: #84b53c;
}
.auth_btn.unactive {
  background-color: #cecece;
}
.auth_text {
  padding: 2px 10px;
  margin-left: 2px;
  color: rgb(22, 93, 255);
  cursor: pointer;
}
.class-title {
  width: 100px;
}

.table-td-cell {
  font-size: 13px;
}

.copy-text {
  font-size: 13px;
  font-weight: 600;
  padding: 0 !important;
}

.td-cz {
  margin-right: 9px;
  margin-bottom: 3px;
  cursor: pointer;
  font-size: 13px;
}
</style>
